import React, { Component } from 'react';
import withi18n from 'weego-common/src/hoc/i18n';

import TicketsManager from '../../../components/tickets/TicketsManager';

class TicketingTransactionsScreen extends Component {
  componentDidMount() {
    const { t } = this.props;
    document.title = t('Tickets');
  }

  render() {
    return <TicketsManager />;
  }
}

export default withi18n('menu')(TicketingTransactionsScreen);
